import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const marketplaceHeaderContent = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    gap: space.s10,
    alignItems: 'start',
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
    },
    tablet: {
      flexDirection: 'row',
    },
  }),
]);

export const marketplaceHeaderTopLine = style([
  responsiveStyle({
    mobile: {
      marginBottom: 0,
    },
    tablet: {
      marginBottom: space.s4,
    },
  }),
]);

export const marketplaceNav = style([
  {
    marginBottom: space.s16,
  },
]);
